import React, { useState } from 'react';
import {Button, Row, Col, Modal, Spin, Typography, notification} from 'antd';
import { formHelper } from "../../../helpers";
import InputField from "../../input-field";
import {userServices} from "../../../services";
import '../modals.css';
import i18n from '../../../i18n';

export default function ModalDeactiveUser({ isShow, onCloseModal, phone}) {
    const {Text} = Typography;
    const [userData, setUserData] = useState([]);
    const [fieldsErrors, setFieldsErrors] = useState(null);
    // const [loading, setLoading] = useState(false);
    const [codeFieldVisible, setCodeFieldVisible] = useState(false);
    const [tokensData, setTokensData] = useState(null);
    const [phoneCode, setPhoneCode] = useState(null);
    const [deactiveShow, setDeactiveShow] = useState(null);
    const [loadingContentModal, setLoadingContentModal] = useState(null);

    const [countryList, setCountryList] = useState([
        {
            Id: 1,
            Name: i18n.t('constants.countries.1')
        },
        {
            Id: 3,
            Name: i18n.t('constants.countries.2')
        }
    ]);

    const getFieldErrors = (nameField) => formHelper.getFieldErrors(nameField, fieldsErrors);

    let bigButtonStyle = {height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', color: "white", borderColor: "transparent" };
    let approveNumberButton = {height: '43px', background: '#2b3f63', position: 'static', borderRadius: '10px', color: "white", borderColor: "transparent", fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '500', lineHeight: '20px' };
    let redButton = {height: '43px', background: 'red', position: 'static', borderRadius: '10px', color: "white", borderColor: "transparent", fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '500', lineHeight: '20px' };

    const handleRecieveCodes = (e) => {
      userServices
        .getSmsApprovePhone({phone})
        .then((data) => {
          if (data.status === "error") {
            notification.error({
              message: i18n.t('components.notification.titles.getSmsVerification'),
              description: data.message,
            });
            setCodeFieldVisible(false);
          } else {
            notification.success({
              message: i18n.t('components.notification.titles.getSmsApprovePhone.success'),
            });
            setCodeFieldVisible(true);
            setTokensData(data);
          }
          if (data.errors) {
            setFieldsErrors(data.errors);
          }
        })
        .catch((error) => {
          setCodeFieldVisible(false);
          notification.error({
            message: i18n.t('components.notification.titles.getSmsApprovePhone.error'),
            description: error,
          });
        });
    };

    const handleGetUserInfoViaCodes = (e) => {
      setLoadingContentModal(true);
      userServices
        .getUserInfoByPhone({
          phoneToken: tokensData.token,
          phoneCode,
          phone,
        })
        .then((data) => {
          if (data.status === "error") {
            notification.error({
              message: i18n.t('components.notification.titles.getUserInfoByPhone'),
              description: data.message,
            });
            setDeactiveShow(false);
            setUserData([]);
            setLoadingContentModal(true);
          } else {
            notification.success({
              message: i18n.t('components.notification.titles.getUserInfoByPhone'),
              description: data.message,
            });
            setDeactiveShow(true);
            setUserData(data);
            setLoadingContentModal(false);
          }
          if (data.errors) {
            setFieldsErrors(data.errors);
          }
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.getUserInfoByPhone'),
            description: error,
          });
        });
    };

    const handleDeactiveUserViaCodes = (e) => {
      userServices
        .deactiveUserByPhone({
          phoneToken: tokensData.token,
          phoneCode,
          phone,
        })
        .then((data) => {
          if (data.status === "error") {
            notification.error({
              message: i18n.t('components.notification.titles.deactiveUserByPhone'),
              description: data.message,
            });
          } else {
            notification.success({
              message: i18n.t('components.notification.titles.deactiveUserByPhone'),
              description: data.message,
            });
            setDeactiveShow(false);
            setUserData([]);
            setTokensData([]);
            onCloseModal();
          }
          if (data.errors) {
            setFieldsErrors(data.errors);
          }
        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.deactiveUserByPhone'),
            description: error,
          });
        });
    };

    return (
        <Modal
            title={<span>{i18n.t('modals.modalDeactiveUser.title')}</span>}
            cancelText={i18n.t('main.buttons.close')}
            style={{ top: 20, minWidth: "700px" }}
            align={null}
            visible={isShow}
            onCancel={() => {
              setTokensData([]);
              setDeactiveShow(false);
              setPhoneCode('');
              onCloseModal();
            }}
            footer={null}
        >
          <Row gutter={[16, 24]}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Text strong style={{fontSize: "20px"}}> {i18n.t('modals.modalDeactiveUser.fields.phone.title')}: {phone}</Text>
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              {codeFieldVisible ? (
                <InputField name="phoneCode" label={i18n.t('modals.modalDeactiveUser.fields.phoneCode.title')}  value={phoneCode} setValue={setPhoneCode} getFieldErrors={getFieldErrors} />
              ) : null}
            </Col>
            <Col lg={12} md={24} sm={24} xs={24} style={{ marginTop: '25px', marginBottom: '15px' }}>
              {codeFieldVisible ? (
                <Button block style={bigButtonStyle} htmlType="button" type="primary" key="change-number" onClick={handleGetUserInfoViaCodes}>
                  {i18n.t('modals.modalDeactiveUser.buttons.getUserInfo')}
                </Button>
              ) : null}
            </Col>
          </Row>
          {deactiveShow ? (
          <Spin spinning={loadingContentModal} tip={i18n.t('main.loadText.loading')}>
            <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
              <Col lg={12} md={12} sm={12} xs={24} className="label dispatch" style={{ marginBottom: '10px' }}>
                {i18n.t('modals.modalDeactiveUser.fields.name.title')}:
              </Col>
              <Col lg={12} md={12} sm={12} xs={24} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
                  {userData.Name}
              </Col>
            </Row>
            <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
              <Col lg={12} md={12} sm={12} xs={24} className="label dispatch" style={{ marginBottom: '10px' }}>
                {i18n.t('modals.modalDeactiveUser.fields.roleName.title')}:
              </Col>
              <Col lg={12} md={12} sm={12} xs={24} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
                  {userData.RoleName}
              </Col>
            </Row>
            <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
              <Col lg={12} md={12} sm={12} xs={24} className="label dispatch" style={{ marginBottom: '10px' }}>
                {i18n.t('modals.modalDeactiveUser.fields.companyName.title')}:
              </Col>
              <Col lg={12} md={12} sm={12} xs={24} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
                  {userData.CompanyName}
              </Col>
            </Row>
            <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
              <Col lg={12} md={12} sm={12} xs={24} className="label dispatch" style={{ marginBottom: '10px' }}>
                {i18n.t('modals.modalDeactiveUser.fields.companyType.title')}:
              </Col>
              <Col lg={12} md={12} sm={12} xs={24} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
                  {userData.CompanyType}
              </Col>
            </Row>
            <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
              <Col lg={12} md={12} sm={12} xs={24} className="label dispatch" style={{ marginBottom: '10px' }}>
                {i18n.t('modals.modalDeactiveUser.fields.consignor.title')}:
              </Col>
              <Col lg={12} md={12} sm={12} xs={24} className="data" style={{ marginBottom: '10px', textAlign: "right" }}>
                  {userData.Consignor}
              </Col>
            </Row>
            <Row gutter={[16, 24]}>
              <Col lg={24} md={24} sm={24} xs={24}>
                <Text strong>
                  <h2>{i18n.t('modals.modalDeactiveUser.text.title')}</h2>
                  <p>{i18n.t('modals.modalDeactiveUser.text.p.1')}</p>
                  <p>{i18n.t('modals.modalDeactiveUser.text.p.2')}</p>
                  <p>{i18n.t('modals.modalDeactiveUser.text.p.3')}</p>
                </Text>
              </Col>
            </Row>
          </Spin> ) : null}
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24} style={{ marginTop: '15px', marginBottom: '15px' }}>
              <Button
                block
                style={approveNumberButton}
                htmlType="button"
                type="primary"
                onClick={handleRecieveCodes}
                key="get-codes"
              >
                {i18n.t('modals.modalDeactiveUser.buttons.approveNumber')}
              </Button>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24} style={{ marginTop: '15px', marginBottom: '15px' }}>
            {deactiveShow ? (
              <Button block style={redButton} htmlType="button" type="primary" key="change-number" onClick={handleDeactiveUserViaCodes}>
                {i18n.t('modals.modalDeactiveUser.buttons.deactive')}
              </Button>
              ) : null}
            </Col>
          </Row>
        </Modal>
    );
}
